import moment from 'moment-timezone'
import * as Ticketure from '@/types/ticketure-api.types'
import { getEventById, getParsedOffsets, getSalesWindowForSession, getSellerById } from '@/utils/transformers.utils'

/**
 * Transform sales window. Calculate inSalesWindow using server time
 * https://app.asana.com/1/23646394350278/project/1206566497440920/task/1210618052534623?focus=true
 * @param {object} args
 * @param {Ticketure.TicketGroup} args.ticketGroup a single ticket group
 * @param {Ticketure.EventTemplate} [args.events] a list of events
 * @param {Ticketure.Seller} [args.sellers] a list of sellers
 * @param {Ticketure.EventSession} [args.sessions] a list of event sessions
 * @returns {SalesWindow} transformed sales window
 */
export const transformSalesWindow = ({
  ticketGroup,
  events,
  sellers,
  sessions,
  nowMoment,
}: {
  ticketGroup: Ticketure.TicketGroupDatum,
  nowMoment?: moment.Moment,
  events?: Ticketure.EventTemplate,
  sellers?: Ticketure.Seller,
  sessions?: Ticketure.EventSession,
}): Transformed.SalesWindow[] => {
  let seller: Ticketure.SellerDatum | undefined
  const inSalesWindow: Transformed.SalesWindow[] = []
  const nextNowMoment = nowMoment || moment()

  const event = getEventById(events, ticketGroup.event_template_id)

  if (event) {
    seller = getSellerById(sellers, event.seller_id)
  }

  if (seller && sessions && sessions._data.length > 0) {
    const offsets = getParsedOffsets({
      startOffset: ticketGroup.sales_start_offset,
      endOffset: ticketGroup.sales_end_offset,
    })

    const now = moment.tz(nextNowMoment, seller.timezone)

    sessions._data.forEach((session) => {
      const {
        id,
        start_datetime: startTime,
        event_template_id,
      } = session

      // only get salesWindows for sessions that match the event id of the ticketGroup
      if (event_template_id === ticketGroup.event_template_id) {
        const nextOffsetForSession = getSalesWindowForSession({
          id,
          offsets,
          timezone: seller.timezone,
          startTime: startTime as string,
          now,
        })
        inSalesWindow.push(nextOffsetForSession)
      }
    })
  }

  return inSalesWindow
}
